import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Logo from "@/v2-backoffice-client/components/Logo"
import useSidebarContext from "./sidebar.context"

export type SidebarBrandingProps = ComponentProps<"div">

function SidebarBranding(props: SidebarBrandingProps) {
  const { isMini } = useSidebarContext()
  const { className, children = "Backoffice", ...divProps } = props
  return (
    <div
      className={cn("sidebar-branding", className, {
        "is-mini": isMini,
      })}
      {...divProps}
    >
      <Logo
        className={cn("sidebar-branding-logo", {
          "sidebar-branding-logo-mini": isMini,
        })}
      />

      {isMini ? null : <div className="sidebar-branding-text">{children}</div>}
    </div>
  )
}

export default SidebarBranding
